import React from 'react';
import { Edit2Icon, Trash2Icon } from 'lucide-react';
const mockStrategies = [{
  id: 1,
  name: 'Campaña Verano 2024',
  type: 'financing',
  description: 'Plan especial de financiamiento para temporada de verano',
  interest_rate: 5.99,
  max_discount: 15,
  min_term: 6,
  max_term: 48,
  status: true
}, {
  id: 2,
  name: 'Descuento Feria Comercial',
  type: 'discount',
  description: 'Descuentos especiales para feria comercial anual',
  interest_rate: 0,
  max_discount: 25,
  min_term: 1,
  max_term: 12,
  status: false
}];
const getTypeLabel = type => {
  const types = {
    financing: 'Plan de Financiación',
    discount: 'Descuento Comercial',
    promotion: 'Promoción Especial'
  };
  return types[type] || type;
};
export const StrategyTable = ({
  onEdit
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-179">
      <div className="overflow-x-auto" data-id="element-180">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-181">
          <thead className="bg-gray-50" data-id="element-182">
            <tr data-id="element-183">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-184">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-185">
                Tipo
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-186">
                Descripción
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-187">
                Tasa/Descuento
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-188">
                Estado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-189">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-190">
            {mockStrategies.map((strategy, index) => <tr key={strategy.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-191">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-192">
                  <div className="text-sm font-medium text-gray-900" data-id="element-193">
                    {strategy.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-194">
                  <div className="text-sm text-gray-500" data-id="element-195">
                    {getTypeLabel(strategy.type)}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-196">
                  <div className="text-sm text-gray-500 truncate max-w-xs" data-id="element-197">
                    {strategy.description}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-198">
                  <div className="text-sm text-gray-900" data-id="element-199">
                    {strategy.type === 'financing' ? `${strategy.interest_rate}% interés` : `${strategy.max_discount}% descuento`}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-200">
                  <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${strategy.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-201">
                    {strategy.status ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-202">
                  <div className="flex space-x-3" data-id="element-203">
                    <button onClick={() => onEdit(strategy)} className="text-blue-600 hover:text-blue-900" data-id="element-204">
                      <Edit2Icon className="h-5 w-5" data-id="element-205" />
                    </button>
                    <button className="text-red-600 hover:text-red-900" data-id="element-206">
                      <Trash2Icon className="h-5 w-5" data-id="element-207" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};